export const handleCountryAutocomplete = (values, objectData) => {
  let stateValue;
  if (values === null) return;

  if (!objectData.id) {
    stateValue = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.formGroup]: {
          ...prevState.newFormData[objectData.formGroup],
          [objectData.code]: values.sifDrzave.toString(),
        },
      },
    });
    return stateValue;
  }

  stateValue = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.formGroup]: [
        ...prevState.newFormData[objectData.formGroup].map((element) =>
          element.id === objectData.id
            ? {
                ...element,
                [objectData.code]: values[objectData.code].toString(),
              }
            : element
        ),
      ],
    },
  });
  return stateValue;
};

export const countryAutocompleteHandler = (values, objectData) => {
  if (values === null) {
    return;
  }
  const newState = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.formGroup]: {
        ...prevState.newFormData[objectData.formGroup],
        sifDrzave: values.sifDrzave.toString(),
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
      },
    },
  });

  return newState;
};

export const countyAutocompleteHandler = (
  values,
  objectData,
  getCityAndMuncipalityList,
  secondaryAddress
) => {
  let newState;
  if (values === null) {
    newState = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.formGroup]: {
          ...prevState.newFormData[objectData.formGroup],
          sifZupanije: "",
          nazZupanije: "",
          sifGrdOpc: "",
          nazGrdOpc: "",
          sifNaselja: "",
          nazNaselja: "",
        },
      },
    });
    return newState;
  }

  newState = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.formGroup]: {
        ...prevState.newFormData[objectData.formGroup],
        sifZupanije: values.sifZupanije.toString(),
        nazZupanije: values.nazZupanije,
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
      },
    },
  });
  getCityAndMuncipalityList(values[objectData.code], secondaryAddress);
  return newState;
};

export const cityAndMuncipalityAutocomplete = (
  values,
  objectData,
  getDistrictList,
  secondaryAddress
) => {
  let newState;
  if (values === null) {
    newState = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.formGroup]: {
          ...prevState.newFormData[objectData.formGroup],
          sifGrdOpc: "",
          nazGrdOpc: "",
          sifNaselja: "",
          nazNaselja: "",
        },
      },
    });

    return newState;
  }
  newState = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.formGroup]: {
        ...prevState.newFormData[objectData.formGroup],
        sifGrdOpc: values.sifGrdOpc.toString(),
        nazGrdOpc: values.nazGrdOpc,
        sifNaselja: "",
        nazNaselja: "",
      },
    },
  });
  getDistrictList(values[objectData.code], secondaryAddress);
  return newState;
};

export const districtAutocompleteHandler = (values, objectData) => {

  let newState;
  if (values === null) {
    newState = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.formGroup]: {
          ...prevState.newFormData[objectData.formGroup],
          sifNaselja: "",
          nazNaselja: "",
        },
      },
    });
    return newState;
  }
  newState = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objectData.formGroup]: {
        ...prevState.newFormData[objectData.formGroup],
        sifNaselja: values.sifNaselja.toString(),
        nazNaselja: values.nazNaselja,
      },
    },
  });

  return newState;
};
